import {
  LOGIN,
  LOGOUT
} from '../constants/ActionTypes';
import { stopSessionReplayRecording } from '../services/datadog';
import notifSystem from '../notifSystem';
import api from '../api';

export function login(token) {
  return {
    type: LOGIN,
    token,
    decodedToken: JSON.parse(
      decodeURIComponent(escape(window.atob(token
        .split('.')[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/'))))
    )
  };
}

export function logout() {
  window.localStorage.removeItem('token');
  stopSessionReplayRecording();
  return {
    type: LOGOUT
  };
}

export const passwordReset = async (login) => {
  try {
    const result = await api.custom('resetPassword').post({
      login,
    });
    notifSystem.success(
      'Message',
      result.body().data()
    );
    return true;
  } catch (error) {
    notifSystem.error(error.name, error.message );
    return false;
  }
};
